// extracted by mini-css-extract-plugin
export default {"form":"styles_form__HneZ1","input":"styles_input__3Modm","buttons":"styles_buttons__ATvt1"};